export const ADDON_ID = {
	DISCOVER: 'com.atlassian.jira.emcee__enduser-discover',
} as const;

export const MENU_ID = {
	ADDONS: 'ADDONS',
	APP_SWITCHER: 'APP_SWITCHER',
	DASHBOARDS: 'DASHBOARDS',
	FILTERS: 'FILTERS',
	HELP: 'HELP',
	HOME: 'HOME',
	INSIGHT: 'INSIGHT',
	NOTIFICATIONS: 'NOTIFICATIONS',
	PEOPLE: 'PEOPLE',
	PLANS: 'PLANS',
	PROFILE: 'PROFILE',
	PROJECTS: 'PROJECTS',
	ROADMAPS: 'ROADMAPS',
	SEARCH: 'SEARCH',
	SERVICE_HUB: 'SERVICE_HUB',
	SETTINGS: 'SETTINGS',
	HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
} as const;
